import datePickerCss from '@vuepic/vue-datepicker/dist/main.css?inline'

let hasInjectedDatePickerCss = false

export function ensureDatePickerCss() {
  if (hasInjectedDatePickerCss || typeof document === 'undefined') return

  const style = document.createElement('style')
  style.setAttribute('data-vue-datepicker-css', 'true')
  style.textContent = datePickerCss
  document.head.appendChild(style)

  hasInjectedDatePickerCss = true
}
